// frontend/src/layouts/BaseLayout.jsx

import React, { useState, useEffect } from 'react'
import '../styles/default.css'
import '../styles/layout.css'
import '../styles/components.css'
import { Outlet, useLocation } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core'
import { LanguageProvider } from '../i18n/LanguageContext'
import LanguageSwitcher from '../components/LanguageSwitcher'
import ThemeToggle from '../components/ThemeToggle';
import LogoutButton from '../components/LogoutButton';
import { getStoredSession } from '../hooks/useHashSession';
import { ThemeProvider, useTheme } from '../contexts/ThemeContext'

import {
  faBan,
  faCheck,
  faCheckCircle,
  faClock,
  faEnvelope,
  faFolderClosed,
  faFileExcel,
  faFilter,
  faLink,
  faLock,
  faLockOpen,
  faMinusCircle,
  faPencilAlt,
  faPlus,
  faSignOutAlt,
  faTrash,
  faTriangleExclamation,
  faUndo,
  faUsers
} from '@fortawesome/free-solid-svg-icons'

// Registrar íconos globalmente
library.add(
  faBan,
  faCheck,
  faCheckCircle,
  faClock,
  faEnvelope,
  faFolderClosed,
  faFileExcel,
  faFilter,
  faLink,
  faLock,
  faLockOpen,
  faMinusCircle,
  faPencilAlt,
  faPlus,
  faSignOutAlt,
  faTrash,
  faTriangleExclamation,
  faUndo,
  faUsers
)

const appName = process.env.REACT_APP_NAME || 'Goval Entry'

function LayoutInner() {
  const location = useLocation()
  const [sessionActive, setSessionActive] = useState(false)
  const { isDark, mounted } = useTheme()

  const logoLight = '/assets/logo.png'
  const logoDark  = '/assets/logo_dark_mode.png'

  useEffect(() => {
    const jwtToken = sessionStorage.getItem('jwt_token')
    const hashSession = getStoredSession()
    setSessionActive(!!jwtToken || !!hashSession)
  }, [location])

  if (!mounted) return null

  return (
    <LanguageProvider>
      <div className="layout-container">
        <div className="layout-body">
          <header className="layout-header">
            <div className="layout-logo">
              <div className="w-14 h-14 md:w-20 ">
                <img
                  src={isDark ? logoDark : logoLight}
                  alt={`Logo ${appName}`}
                  className="w-full h-full object-contain"
                />
              </div>
              <h2 className="text-xl md:text-lg font-bold tracking-tight">
                {appName}
              </h2>
            </div>

            <div className="flex items-center gap-2 md:gap-1.5">
              <div className="icon-button w-11 h-11">
                <LanguageSwitcher />
              </div>
              <div className="icon-button w-11 h-11">
                <ThemeToggle />
              </div>
              {sessionActive && <LogoutButton />}
            </div>
          </header>

          <main className="layout-main">
            <div className="layout-main-inner">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </LanguageProvider>
  )
}

export default function BaseLayout() {
  return (
    <ThemeProvider>
      <LayoutInner />
    </ThemeProvider>
  )
}